<template>
  <div class="card">
    <div class="card-body">
      <!-- <div v-if="coordinator" class="bg-green rounded text-center text-white mb-1 p-2 uppercase">      
        <span v-if="$route.params.language === 'pt'">Coordenador</span>
        <span v-if="$route.params.language === 'en'">Coordinator</span>
        <span v-if="$route.params.language === 'es'">Coordenador</span>
      </div>
      <div v-if="mediator" class="bg-blue rounded text-center text-white mb-1 p-2 uppercase">      
        <span v-if="$route.params.language === 'pt'">Moderador</span>
        <span v-if="$route.params.language === 'en'">Moderator</span>
        <span v-if="$route.params.language === 'es'">Moderador</span>
      </div> -->
      <div class="row">
        <div class="col-sm-12 col-md-3">
          <div class="person-photo">
            <img v-if="person.photo" :src="'https://res.cloudinary.com/dstsh6x0y/image/upload/c_scale,w_150/v1532395371/futurecom2019/'+person.photo" alt="">
          </div>
        </div>
        <div class="col-sm-12 col-md-9">
          <span v-if="coordinator" class="badge badge-pill badge-primary">
            <span v-if="$route.params.language === 'pt'">Coordenador</span>
            <span v-if="$route.params.language === 'en'">Coordinator</span>
            <span v-if="$route.params.language === 'es'">Coordenador</span>
          </span>
          <span v-if="mediator" class="badge badge-pill badge-secondary">
            <span v-if="$route.params.language === 'pt'">Moderador</span>
            <span v-if="$route.params.language === 'en'">Moderator</span>
            <span v-if="$route.params.language === 'es'">Moderador</span>
          </span>
          <h4 class="text-left">{{ person.name }}</h4>
          <p class="text-left">
            <span v-if="$route.params.language === 'pt'">{{ person.job_title_pt }}</span>
            <span v-if="$route.params.language === 'en'">{{ person.job_title_en }}</span>
            <span v-if="$route.params.language === 'es'">{{ person.job_title_es }}</span>
          </p>
          <img v-if="person.company.logo" class="w-1/3 m-auto my-3" :src="'https://res.cloudinary.com/dstsh6x0y/image/upload/c_scale,w_100/v1532395371/futurecom2019/'+person.company.logo" alt="">
          <p v-else class="text-left">
            <span v-if="$route.params.language === 'pt'">{{ person.company.company_pt }}</span>
            <span v-if="$route.params.language === 'en'">{{ person.company.company_en }}</span>
            <span v-if="$route.params.language === 'es'">{{ person.company.company_es }}</span>
          </p>
          <p style="margin-top: 10px">
            <span v-if="$route.params.language === 'pt'">{{ person.curriculum_pt }}</span>
            <span v-if="$route.params.language === 'en'">{{ person.curriculum_en }}</span>
            <span v-if="$route.params.language === 'es'">{{ person.curriculum_es }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'People',
    props: ['person', 'coordinator', 'mediator'],
    data() {
      return {
        over: false
      }
    },
    methods: {
      mouseOver() {
        this.over = true
      },
      mouseLeave() {
        setTimeout(() => {          
          this.over = false
        }, 100);
      }
    }
  }
</script>

<style scoped>
  .card{
    margin-top: 20px;
  }
  .person-photo{
    width: 150px;
    height: 150px;
    overflow: hidden;
    border-radius: 150px;
  }
  .person-photo img{
    width: 152px;
    height: auto;
  }
</style>




// WEBPACK FOOTER //
// src/components/info/People.vue